module.exports = __webpack_public_path__ + "img/plus.b6228818.svg";